/**
 * @desc 作废调拨计划单
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/allocationPlan/cancel`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
